// extracted by mini-css-extract-plugin
export default {"checkboxWrapper":"styles_checkboxWrapper__7Vdcl","checkBox":"styles_checkBox__XoZoU"};